import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
  blogImage1,
  avatar11,
  avatar12,
  avatar13,
} from '../../assets/images'
import BlogSidebar from '../../components/blog/BlogSidebar'

export default function BlogDetail() {

  const commentItem = [
    {
      image: avatar11,
      name: "Gigi Hadid",
      comment: "Why are there so many tutorials on how to decouple WordPress? how fast and easy it is to get it running (and keep it running!) and its massive ecosystem.",
      date: "Mar 09 2018",
    },
    {
      image: avatar12,
      name: "Christian Louboutin",
      comment: "Great tutorial but few issues with it? If i try open post i get following errors. Please can you help me?",
      date: "Mar 12 2018",
    },
    {
      image: avatar13,
      name: "Kendall Jenner",
      comment: "Very nice and informative article. In all the years I've done small and side-projects as a freelancer, I've ran into a few problems here and there.",
      date: "Mar 20 2018",
    },
  ]

  return (
    <>
      <Breadcrumb title="Blog Details" path="Blog / Blog Details" />
      <div className='grid lg:grid-cols-[8fr_4fr] grid-cols-1 gap-30'>
        <div>
          <div className='bg-bg-dark rounded-lg shadow-light lg:p-30 md:p-20 p-15 mb-30'>
            <div className='flex group overflow-hidden'>
              <img src={blogImage1} width="1100" height="600" alt='blog post' className='w-full lg:h-[500px] object-cover transition-all duration-700 group-hover:scale-[1.02] group-hover:grayscale' />
            </div>
            <p className='uppercase text-[20px]/[24px] font-medium mt-30'>
              ALL PHOTOGRAPHS ARE ACCURATE
            </p>
            <p className='mt-10 text-[16px]/[26px]'>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </p>
          </div>
          <div className='bg-bg-dark rounded-lg shadow-light lg:p-30 md:p-20 p-15 mb-30'>
            <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
              Comments 3
            </p>
            {commentItem.map((item, key) => (
              <div key={key} className='flex sm:gap-15 gap-5 sm:flex-row flex-col items-start mb-30 last:mb-0'>
                <div className='p-1 border border-border rounded min-w-fit'>
                  <img src={item.image} width="90" height="90" alt='avatar' className='sm:w-[90px] sm:h-[90px] w-[50px] h-[50px] object-cover' />
                </div>
                <div>
                  <p className='text-[18px]/[22px] font-medium mb-5'>
                    {item.name}
                  </p>
                  <p className='text-[15px]/[22px] text-text-secondary mb-5'>
                    {item.comment}
                  </p>
                  <p className='flex items-center gap-20'>
                    <span className="text-blue transition duration-300 hover:text-blue-100">
                      {item.date}
                    </span>
                    <button className="text-blue transition duration-300 hover:text-blue-100">
                      Reply
                    </button>
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
            <p className='text-[16px]/[20px] font-medium mb-5'>
              Leave a reply
            </p>
            <p className='mb-30 text-text-secondary'>
              Your email address will not be published. Required fields are marked*
            </p>
            <div className='flex flex-col gap-20'>
              <div className='grid md:grid-cols-2 gap-20'>
                <div className='form-group'>
                  <input type='text' id='blogCommentName' name='blogCommentName' placeholder='Your Name' />
                </div>
                <div className='form-group'>
                  <input type='email' id='blogCommentEmail' name='blogCommentEmail' placeholder='Email Address' />
                </div>
              </div>
              <div className='form-group flex'>
                <textarea rows={5} placeholder='Please type what you want...' />
              </div>
              <button className="btn btn-primary uppercase">
                Submit
              </button>
            </div>
          </div>
        </div>
        <BlogSidebar />
      </div>
    </>
  )
}
